<template>
  <div class="flex-column align-items-center padding0 gap24 stretch">
    <div class="grid-container stretch">
      <div class="whitecard align-items-center gap16">
        <div class="flex-row align-items-center padding4">
          <IllustrationsMoney />
        </div>
        <div
          v-if="!isBusiness"
          class="flex-column gap-4 grow"
        >
          <p class="has-text-size-14 bold">
            {{ $t("bnpl:psd2monthlyNetIncome") }}
          </p>
          <p class="has-text-grey">
            {{ $t("bnpl:psd2byAvarageMonthlyData") }}
          </p>
          <h4 class="h bold">
            {{ $n(data.lastSyncData.salary, "currency") }}
          </h4>
        </div>
        <div
          v-else
          class="flex-column gap-4 grow"
        >
          <p class="has-text-size-14 bold">
            {{ $t("bnpl:psd2_b2b_monthly_income") }}
          </p>
          <p class="has-text-grey">
            {{ $t("bnpl:psd2_by_avarage_monthly_data") }}
          </p>
          <h4 class="h bold">
            {{ $n(data.lastSyncData.externalIncomeAmount, "currency") }}
          </h4>
        </div>
      </div>
      <div class="whitecard align-items-center gap16">
        <div class="flex-row align-items-center padding4">
          <IllustrationsReceipt />
        </div>
        <div
          v-if="!isBusiness"
          class="flex-column gap-4 grow"
        >
          <p class="has-text-size-14 bold">
            {{ $t("bnpl:psd2monthlyDebt") }}
          </p>
          <p class="has-text-grey">
            {{ $t("bnpl:psd2byAvarageMonthlyData") }}
          </p>
          <h4 class="h bold">
            {{ $n(data.lastSyncData.loanAmount, "currency") }}
          </h4>
        </div>
        <div
          v-else
          class="flex-column gap-4 grow"
        >
          <p class="has-text-size-14 bold">
            {{ $t("bnpl:psd2_b2b_monthly_expense") }}
          </p>
          <p class="has-text-grey">
            {{ $t("bnpl:psd2_by_avarage_monthly_data") }}
          </p>
          <h4 class="h bold">
            {{ $n(data.lastSyncData.externalExpenseAmount, "currency") }}
          </h4>
        </div>
      </div>
    </div>
    <div class="whitebox flex-row align-items-center padding16 gap8 stretch">
      <div class="flex-column align-items-start padding0 gap8 grow">
        <p class="p-caption bold">
          {{ $t("bnpl:psd2useMoreBankAccount") }}
        </p>
        <p class="p-caption">
          {{ $t("bnpl:psd2useMoreBankAccountDescription") }}
        </p>
      </div>
      <button
        id="bnpl_psd2_add_bank_account"
        class="linkButton has-text-size-14"
        @click="addBankAccount"
      >
        {{ $t("bnpl:psd2addBankAccount") }}
      </button>
    </div>
    <Psd2MistakeFound :flow="flow" />
  </div>
</template>

<script setup>
  const props = defineProps({
    flow: {
      type: Object,
      required: true,
    },
  });

  const data = computed(() => props.flow.sync);
  const isBusiness = props.flow.isBusiness;

  /** Another account means another sync, which starts where the first one did. */
  function addBankAccount() {
    props.flow.restart();
  }
</script>

<style lang="scss" scoped>
.padding4 {
  padding: 4px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 24px;
}

.whitecard {
  display: flex;
  align-items: center;
  padding: 12px;
}

.linkButton {
  font-size: 12px;
  color: var(--brandPrimary);
}

@media only screen and (max-width: 792px) {
  .grid-container {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
  